export default __webpack_public_path__ + "static/media/吴杰庄议员办公区.ffeb5018.jpg";